import { mapIntegrationProviderFromDTO } from '@/modules/common/mappers/integration.mapper';
import { IntegrationProviderDTO } from '@/modules/common/types/dto/response/integration-response';

import { Project } from '../types/projects.types';

export function mapProjectFromDTO(raw: any): Project {
  return {
    ...raw,
    connectedIntegrations: ((raw.connectedIntegrations ?? []) as IntegrationProviderDTO[]).map(
      mapIntegrationProviderFromDTO
    ),
    ignoredIntegrations: ((raw.ignoredIntegrations ?? []) as IntegrationProviderDTO[]).map(
      mapIntegrationProviderFromDTO
    ),
  };
}
